import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {
        Person:{},
        Organization:{}
    },
    status: 'idle', // idle loading success fail  
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
const WELLSUITE = '../../WsWebServiceWellSuite/';

export const setPersonSettings = createAsyncThunk('setting/set', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.get(PLATFORM 
                                            + "Participant/Setting/Set/" 
                                            + incomingVariable.authToken + "/" 
                                            + incomingVariable.ParticipantGuid + "/"
                                            + incomingVariable.SettingKeyName.replace(" ", "%20") + "/"
                                            + incomingVariable.SettingValue + "/"
                                            
                                        )
        const data = await response.data

        return data
    } catch (err) {
        
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const setPersonLanguage = createAsyncThunk('languagesetting/set', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.get(PLATFORM 
                                            + "Participant/Language/Update/" 
                                            + incomingVariable.authToken + "/" 
                                            + incomingVariable.LanguageId + "/"
                                            
                                            
                                        )
        const data = await response.data

        return data
    } catch (err) {
        
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const deletePersonSettings = createAsyncThunk('setting/delete', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.get(PLATFORM 
                                            + "Participant/Setting/Delete/" 
                                            + incomingVariable.authToken + "/" 
                                            + incomingVariable.ParticipantGuid + "/"
                                            + incomingVariable.SettingKeyName.replace(" ", "%20") + "/"
                        
                                            
                                        )
        const data = await response.data

        return data
    } catch (err) {
        
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})


const settingSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {        
        settingClear(state, action) {
            state.entities = initialState
            state.status = "idle"
            state.error = null
            
        }
    },
    extraReducers(builder) {
        builder
            //
            .addCase(setPersonSettings.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(setPersonSettings.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if(Success===true){
                    state.status = 'success'
                    const loadedData = action.payload.Info[0]
                    state.entities.Person[loadedData.SettingName] = loadedData.SettingValue
                    state.error=null
                } else {
                    state.error = action.payload.Status[0]
                    state.status='failed'
                }
            })
            .addCase(setPersonSettings.rejected, (state, action) => {
                state.error = action.error.message
                
            })
            
            
    }
})

export const { settingClear} = settingSlice.actions

export default settingSlice.reducer

export const selectSettingEntities = (state) => state.setting.entities

export const selectSettings = createSelector(selectSettingEntities, (entities) =>
    Object.values(entities)
)

export const selectSettingById = (state, SettingId) => {
    return selectSettingEntities(state)[SettingId]
}

